import Timeline from './timeline';
import TimelineItem from './timeline-item';
var DefaultTimeline = Timeline;
DefaultTimeline.Item = TimelineItem;
export default DefaultTimeline;
//# sourceMappingURL=index.js.map